import React from 'react';
import { Link } from 'react-router';
import type { Candidate } from '@axiom/validation';
import { Gutter, Paragraph } from '@axiom/ui';

export type ProfileHighlightsFocusAreaBarsSubtitleProps = {
  candidate: Candidate;
};

export const ProfileHighlightsFocusAreaBarsSubtitle = ({
  candidate,
}: ProfileHighlightsFocusAreaBarsSubtitleProps) => {
  return (
    <div data-test="PROFILE_HIGHLIGHTS_FOCUS_AREA_BARS_SUBTITLE">
      <Paragraph>
        Top focus areas show where you have the most legal experience, both when
        Axiom submits your profile to clients for an opportunity and when
        clients find you on Axiom’s digital platform. You can also customize
        your top focus areas for an opportunity to ensure your most relevant
        experience and skills are highlighted for Axiom and the client.
      </Paragraph>
      <Gutter bottom="16px" />
      {candidate.isSpotlightedLawyer ? (
        <Paragraph name="VISIBILITY_MESSAGE">
          Your profile with these focus areas is currently visible to clients on
          Axiom's digital platform.
        </Paragraph>
      ) : (
        <Paragraph name="VISIBILITY_MESSAGE">
          Your profile with these focus areas is not currently visible to
          clients on Axiom's digital platform. You can change this setting in{' '}
          <Link
            data-test="PROFILE_VISIBILITY_LINK"
            to="../preferences/profile-visibility"
          >
            Profile Visibility preferences.
          </Link>
        </Paragraph>
      )}
    </div>
  );
};
